namespace TabAurous {

    @Serenity.Decorators.registerEditor()
    export class CommonProductSizeLookup extends
        Serenity.LookupEditorBase<Serenity.LookupEditorOptions, OMS.ProductSizeMasterRow> {

        public CategoryId: number;

        constructor(container: JQuery, opt: Serenity.LookupEditorOptions) {
            super(container, opt);
        }

        protected getLookupKey() {
            return OMS.ProductSizeMasterRow.lookupKey;
        }

        protected getItems(lookup: Q.Lookup<any>) {
            var results = Q.getLookup(OMS.ProductSizeMasterRow.lookupKey);
            
            let items = super.getItems(results);
            if (q.isNumber(this.CategoryId)) {

                let filters = {
                    CategoryId: [this.CategoryId, 0]
                };
                
                items = q.Filter(results.items, filters)
            }              
            return items;
        }

    }

    
}
